import styled from 'styled-components';

export const Search = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;

  padding-left: 20px;
  box-sizing: border-box;
  > .bg-img-wrapper {
    position: absolute;
    z-index: -1000;
    top: -7px;
    bottom: -7px;
    left: -4px;
    right: -4px;
  }
  > .bg-img {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
  }
`;

export const SearchIconBlock = styled.div`
  position: relative;
  z-index: 1;
  width: 13px;
  height: 14px;

  > .search-icon-wrapper {
    position: absolute;
    top: -5px;
    bottom: -6px;
    left: -6px;
    right: -7px;
    > .search-icon {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }
  }
`;

export const SearchInputWrapper = styled.div`
  flex-grow: 1;
  height: 100%;
  > .search-input {
    width: 100%;
    height: 100%;

    font-size: 14px;
    font-family: PingFangSC;
    font-weight: 400;
    color: rgba(255, 255, 255, 0.6);
    padding: 0 16px;
  }
`;

export const SearchButton = styled.button`
  width: 106px;
  height: 100%;

  font-size: 16px;
  font-family: PingFangSC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);

  background-image: url(${require('../img/search-btn-bg.png')});
  background-size: 100% 100%;
  padding-left: 15px;
`;

export const HotWord = styled.div`
  width: 425px;
  position: absolute;
  left: 0;
  bottom: 0;
  transform: translateY(100%);
`;
